import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { Typography, Box, Container, Paper } from "@mui/material";
import Button from "@mui/material/Button";

const SignInButton = () => {
  const { instance, accounts } = useMsal();

  useEffect(() => {
    // Function to perform silent token acquisition
    const getAccessTokenSilently = async () => {
      const silentRequest = {
        scopes: loginRequest.scopes,
        account: accounts[0], // Ensure that there's at least one account
      };

      try {
        await instance.acquireTokenSilent(silentRequest);
        console.log("Token acquired silently, user is already logged in.");
        // Handle post-login logic here if needed
      } catch (error) {
        console.log(
          "No active session, user needs to sign in interactively.",
          error
        );
        // If silent login fails, you can optionally show the login button
        // or automatically prompt login popup here
        handleLogin();
      }
    };

    if (accounts.length > 0) {
      getAccessTokenSilently(); // Attempt silent login if there are accounts
    }
  }, [instance, accounts]);

  const handleLogin = () => {
    instance
      .loginPopup(loginRequest)
      .then((response) => {
        console.log("Login successful", response);
      })
      .catch((e) => {
        console.error("Login failed", e);
      });
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            mt: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Button
            type="button"
            fullWidth
            variant="contained"
            sx={{
              mt: 3,
              mb: 2,
              backgroundColor: "#2F2F2F",
              ":hover": { backgroundColor: "#434343" },
            }}
            onClick={handleLogin}
          >
            <img
              src={`${process.env.PUBLIC_URL}/microsoft-login.png`}
              alt="Microsoft Login"
              style={{ marginRight: 10, height: 24 }}
            />
            Login with Microsoft
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default SignInButton;
